<template>
  <v-btn
    :class="
      'd-flex fill-height elevation-0 py-2 justify-start new-sideber-item ' +
      classButton
    "
    v-bind="[$attrs, $props]"
    v-on="$listeners"
    min-height="20px"
    :disabled="isFixed"
    depressed
    text
    :ripple="false"
  >
    <SvgIcon
      :name="item.svgIcon"
      :color="customIconColor"
      class="sidebar-icon"
      :style="iconCssVariables"
      v-if="isImage && item.svgIcon"
    />
    <v-badge
      :color="selected ? 'orangeNotification' : mini ? 'white' : 'gray50'"
      class="button-common pr-2 mt-1 sidebar-dot"
      v-if="!isImage"
      dot
    />
    <v-badge
      :color="permission ? 'gray50' : 'black'"
      class="button-hover pr-2 mt-1 sidebar-dot"
      v-if="!isImage && !mini"
      dot
    />
    <v-badge
      color="orangeNotification"
      class="bagde-sidebar"
      v-if="
        (item.route === 'notificationHome' && isNotification) ||
        (item.route === 'chatHome' && isMessageNotification) ||
        (item.route === 'profileCommunity' && notificationNewCommunity)
      "
      dot
    />
    <p
      :class="'mb-0 ml-0 item__text subtitle-1 pt-0 ' + colorText"
      v-show="!mini"
    >
      {{ item.name }}
    </p>
    <div
      v-if="
        !mini && item.route === 'timelineHome' && currentTransmission?.id !== 0
      "
      class="pl-3"
    >
      <div
        class="black new-sidebar__transmission-icon d-flex align-center"
        v-if="showLiveIndicator"
      >
        <v-avatar size="8" color="red" />
        <p class="label white--text mb-0 d-inline-flex pl-1">
          {{ $t("transmission.transmissionLive") }}
        </p>
      </div>
      <div class="gray35 px-4 py-1 new-sidebar__transmission-border" v-else>
        <p class="label gray90--text mb-0">
          {{ displayCountdownText }}
        </p>
      </div>
    </div>
  </v-btn>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { State } from "vuex-class";
import SvgIcon from "@/layouts/SvgIcon.vue";
@Component({
  components: {
    SvgIcon,
  },
})
export default class NewSidebarItem extends Vue {
  @Prop(Object) item: any;
  @Prop({ default: false }) mini: boolean;
  @Prop({ default: false }) selected: boolean;
  @Prop(Boolean) isNotification: boolean;
  @Prop(Boolean) isMessageNotification: boolean;
  @Prop({ default: true }) isImage: boolean;
  @Prop({ default: false }) isFixed: boolean;
  @Prop(Boolean) isAdmin: boolean;
  @Prop(Boolean) isUser: boolean;
  @Prop({ default: false }) permission: boolean;
  @Prop({ default: false }) right: boolean;
  @State((state) => state.community.notificationNewCommunity)
  notificationNewCommunity: any;
  @State((state) => state.transmission.currentTransmission)
  currentTransmission: any;
  @State((state) => state.profile.me) me: any;

  // Intervalo para atualizar o contador
  countdownInterval: any = null;
  // Texto do contador para exibição
  displayCountdownText = "";
  // Flag para indicar se a transmissão está ao vivo
  showLiveIndicator = false;

  get colorText(): string {
    const padding = this.isImage ? "pl-3" : "pl-7";
    if (this.isFixed || this.permission)
      return `black--text subtitle-1 ${padding}`;
    return this.selected
      ? `purpleBrand--text subtitle-1 ${padding}`
      : `gray70--text subtitle-1 ${padding}`;
  }
  get classButton(): string {
    return this.mini ? "button-sidebar-item px-2" : "px-4";
  }
  get customIcon(): any {
    return this.isFixed
      ? this.mini
        ? this.item.imageUnselected
        : this.item.imageHover
      : this.selected
      ? this.item.imageSelected
      : this.item.imageUnselected;
  }
  get customIconColor(): string {
    if (this.mini && this.me.role === "FOUR_NETWORK" && !this.selected)
      return "white";
    if (this.isFixed && !this.mini) return "black";
    return this.selected
      ? this.mini
        ? this.me.role === "FOUR_NETWORK"
          ? "purple100"
          : this.me.role === "MARKETING"
          ? "purple70"
          : "white"
        : "purple100"
      : "gray50";
  }
  get hoverIconColor(): string {
    return this.mini
      ? this.me.role === "FOUR_NETWORK"
        ? "gray90"
        : this.me.role === "MARKETING"
        ? "white"
        : "purple70"
      : "black";
  }
  get iconCssVariables(): object {
    return {
      "--icon-hover-color": this.getColorValue(this.hoverIconColor),
    };
  }
  getColorValue(colorName: string): string {
    const colorMap: { [key: string]: string } = {
      black: "var(--v-black-base)",
      purple100: "var(--v-purple100-base)",
      purpleBrand: "var(--v-purpleBrand-base)",
      gray70: "var(--v-gray70-base)",
      purple200: "var(--v-purple200-base)",
      white: "var(--v-white-base)",
      gray90: "var(--v-gray90-base)",
    };
    return colorMap[colorName] || colorMap.gray70;
  }
  // Verificar se a transmissão está ao vivo
  get isTransmissionLive(): boolean {
    if (!this.currentTransmission || !this.currentTransmission.startTime) {
      return false;
    }

    // A transmissão está ao vivo se já começou mas ainda não terminou
    return this.hasTransmissionStarted && !this.hasTransmissionEnded;
  }

  // Verifica se a transmissão já começou
  get hasTransmissionStarted(): boolean {
    if (!this.currentTransmission || !this.currentTransmission.startTime) {
      return false;
    }

    const now = new Date().getTime();
    const startTime = new Date(this.currentTransmission.startTime).getTime();

    return now > startTime; // Retorna true se a transmissão já começou
  }

  // Verifica se a transmissão já terminou
  get hasTransmissionEnded(): boolean {
    if (!this.currentTransmission || !this.currentTransmission.startTime) {
      return false;
    }

    const now = new Date().getTime();
    const startTime = new Date(this.currentTransmission.startTime).getTime();
    const endTime = startTime + this.currentTransmission.duration * 60 * 1000;

    return now > endTime; // Retorna true se a transmissão já terminou
  }
  get countdownText(): string {
    if (!this.currentTransmission || !this.currentTransmission.startTime) {
      return "";
    }

    const now = new Date().getTime();
    const startTime = new Date(this.currentTransmission.startTime).getTime();
    const endTime = startTime + this.currentTransmission.duration * 60 * 1000; // Duração em milissegundos

    // Verificar se a transmissão já terminou
    if (now > endTime) {
      return ""; // Transmissão encerrada
    }

    const timeRemaining = startTime - now;

    // Se a transmissão já começou (mas ainda não terminou)
    if (timeRemaining <= 0) {
      // Verificar se a transmissão está ao vivo
      if (this.isTransmissionLive) {
        return this.$t("transmission.transmissionLive").toString();
      }
      return "";
    } else {
      // A transmissão ainda não começou, calcular o tempo restante
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      // Formatar a saída com base no tempo restante
      if (days > 0) {
        return `${days}d ${hours}h ${minutes}m ${seconds}s`;
      } else if (hours > 0) {
        return `${hours}h ${minutes}m ${seconds}s`;
      } else if (minutes > 0) {
        return `${minutes}m ${seconds}s`;
      } else {
        // Menos de 1 minuto para começar
        return `${seconds}s`;
      }
    }
  }

  // Método para iniciar o intervalo de contagem regressiva
  startCountdownInterval() {
    // Não iniciar o intervalo se não houver transmissão
    if (!this.currentTransmission || !this.currentTransmission.startTime) {
      return;
    }

    // Limpar intervalo existente se houver
    if (this.countdownInterval) {
      this.clearCountdownInterval();
    }

    // Verificar o estado inicial da transmissão
    this.checkTransmissionStatus();

    // Atualizar a cada segundo
    this.countdownInterval = setInterval(() => {
      // Verificar se a transmissão ainda existe
      if (!this.currentTransmission || !this.currentTransmission.startTime) {
        this.clearCountdownInterval();
        return;
      }

      // Verificar o estado atual da transmissão
      this.checkTransmissionStatus();

      // Forçar a renderização para garantir que as mudanças sejam aplicadas
      this.$forceUpdate();

      // Se a transmissão terminou, limpar o intervalo
      if (this.hasTransmissionEnded) {
        this.clearCountdownInterval();
      }
    }, 1000);
  }

  // Método para limpar o intervalo de contagem regressiva
  clearCountdownInterval() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }

  // Método para verificar o status da transmissão e atualizar a interface
  checkTransmissionStatus() {
    if (!this.currentTransmission || !this.currentTransmission.startTime) {
      this.displayCountdownText = "";
      this.showLiveIndicator = false;
      return;
    }

    const now = new Date().getTime();
    const startTime = new Date(this.currentTransmission.startTime).getTime();
    const endTime = startTime + this.currentTransmission.duration * 60 * 1000;

    // Verificar se a transmissão já terminou
    if (now > endTime) {
      this.displayCountdownText = "";
      this.showLiveIndicator = false;
      return;
    }

    const timeRemaining = startTime - now;

    // Verificar se a transmissão está ao vivo
    if (timeRemaining <= 0) {
      // A transmissão já começou, mostrar o indicador de ao vivo
      this.showLiveIndicator = true;
      this.displayCountdownText = "";
    } else {
      // A transmissão ainda não começou, mostrar o contador
      this.showLiveIndicator = false;

      // Calcular o tempo restante
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      // Formatar a saída com base no tempo restante
      if (days > 0) {
        this.displayCountdownText = `${days}d ${hours}h ${minutes}m ${seconds}s`;
      } else if (hours > 0) {
        this.displayCountdownText = `${hours}h ${minutes}m ${seconds}s`;
      } else if (minutes > 0) {
        this.displayCountdownText = `${minutes}m ${seconds}s`;
      } else {
        // Menos de 1 minuto para começar
        this.displayCountdownText = `${seconds}s`;
      }
    }
  }
  // Inicializar o intervalo de contagem regressiva quando o componente for montado
  mounted() {
    this.startCountdownInterval();
  }

  // Limpar o intervalo quando o componente for destruído
  beforeDestroy() {
    this.clearCountdownInterval();
  }

  // Observar mudanças na propriedade currentTransmission
  @Watch("currentTransmission", { deep: true })
  onCurrentTransmissionChanged(newVal: any, oldVal: any) {
    // Verificar se realmente mudou para evitar loops
    if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
      // Reiniciar o intervalo quando a transmissão atual mudar
      this.clearCountdownInterval();
      this.startCountdownInterval();
    }
  }
}
</script>
<style lang="sass" scoped>
.v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before
  opacity: 0 !important
.theme--light.v-btn--active:before
  opacity: 0 !important
.new-sideber-item.v-btn:before
  opacity: 0 !important
.new-sideber-item
  width: 100%
  border: 1px solid transparent
  transition: background 0.5s ease, border-color 0.5s ease
.item__text
  margin-left: 14px
  padding-top: 3px
  text-transform: none !important
.new-sideber-item:hover:not(.v-btn--disabled)
  .item__text
    color: var(--v-black-base) !important
.new-sideber-item:active:not(.v-btn--disabled)
  background: var(--v-purplePale-base) !important
  .item__text
    color: var(--v-purpleBrand-base) !important
.new-sideber-item:focus-visible:not(.v-btn--disabled)
  border-radius: 8px
  border: 1px solid var(--v-tealFocus-base)
  outline: none
  .item__text
    color: var(--v-gray70-base) !important
.selected-item
  border-left: 2px solid var(--v-purpleBrand-base) !important
.button-sidebar-item
  min-width: 50px !important
.icon-sidebar
  width: 21px !important
.bagde-sidebar
  top: -5px
  left: -7px
  .v-badge__badge
    border-radius: 6px !important
    height: 12px !important
    min-width: 0
    padding: 0
    width: 12px !important
.new-sideber-item .button-hover
  display: none
.new-sideber-item:hover .button-hover
  display: block
.new-sideber-item:hover .button-common
  display: none

.new-sideber-item:hover:not(.v-btn--disabled) .sidebar-icon
  ::v-deep svg *
    fill: var(--icon-hover-color) !important
.new-sideber-item:active:not(.v-btn--disabled) .sidebar-icon
  ::v-deep svg *
    fill: var(--v-purpleBrand-base) !important
.new-sideber-item:focus-visible:not(.v-btn--disabled) .sidebar-icon
  ::v-deep svg *
    fill: var(--v-gray70-base) !important
.theme--light.v-btn.v-btn--disabled.new-sideber-item, .theme--light.v-btn.new-sideber-item.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn-outlined), .theme--light.v-btn.new-sideber-item.v-btn--disabled.v-btn--has-bg
  border: none !important
.new-sidebar__
  &transmission-icon
    padding: 2px 12px 2px 8px
    border-radius: 24px
  &transmission-border
    border-radius: 24px
</style>
